module.exports = __webpack_public_path__ + "e8e597e062d9b6c9413be5720cea0e79.MP3";